import { Language } from "../languages/labels/language.labels";

export function sourceTypeList(lang: Language): {code: string, display: string}[] {
  return [
    { code: 'provider-invoice', display: lang.labels.providerInvoice },
    { code: 'provider-order', display: lang.labels.providerOrder },
    { code: 'invoice', display: lang.labels.invoice },
    { code: 'order', display: lang.labels.order },
    { code: 'sale', display: lang.labels.sale },
    { code: 'delivery-note', display: lang.labels.deliveryNote },
    { code: 'consignment', display: lang.labels.consignment },
    { code: 'consignment-return', display: lang.labels.consignmentReturn },
    { code: 'manual', display: lang.labels.manual }
  ]
}

export function sourceTypeValue(lang: Language, code: string): string {
  if (!code) return '-'
  let sourceType = sourceTypeList(lang).find((item) => (item.code === code))
  return sourceType ? sourceType.display : code
}
